import { Button, Typography } from '@mui/material'
import { useRouteError } from 'react-router-dom'
import { invalidTokenErrors } from 'shared/graphql/client'
import { getPxAsRem } from 'shared/utils'

// TODO: update error boundary to better reset things / be more user friendly
function ErrorBoundary() {
    let error: any = useRouteError()
    console.log(error?.message)
    // avoid splash of error page before redirecting you to log in
    if (error?.message && invalidTokenErrors.includes(error.message))
        return null
    // fallback for non-auth errors
    return (
        <div
            style={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: getPxAsRem(24),
            }}
        >
            <Typography variant="h3" component="h1">
                Something went wrong!
            </Typography>
            <Button href="/">Return Home</Button>
        </div>
    )
}

export default ErrorBoundary
